import React from 'react';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import NYCFooter from '../Layout/NYCFooter';
import SFFooter from '../Layout/SFFooter';
import TorontoFooter from '../Layout/TorontoFooter';
import LatestNews from './LatestNews';
import './newsroom.css';
import Resources from './Resources';

const Newsroom = props => {
  const pathname = props.match.path;
  return (
    <Fragment>
      <Helmet>
        <title>Autzu Newsroom</title>
        <meta
          name="description"
          content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
        />
      </Helmet>
      <div className="newsroomPage container">
        <LatestNews />
        <Resources />
        <TorontoFooter />
      </div>
    </Fragment>
  );
};

export default Newsroom;



// WEBPACK FOOTER //
// ./src/components/Newsroom/index.js